// istanbul ignore file
import type { ReportMessageAttachmentClickedFromLinkClickProps } from './reportMessageAttachmentClickedFromLinkClick';

export const lazyReportMessageAttachmentClickedFromLinkClick = async (
  props: ReportMessageAttachmentClickedFromLinkClickProps
): Promise<void> => {
  const { reportMessageAttachmentClickedFromLinkClick } = await import(
    /* webpackChunkName: "4-feat-report-message-attachment-clicked" */ './reportMessageAttachmentClickedFromLinkClick'
  );
  reportMessageAttachmentClickedFromLinkClick(props);
};
